import { memo } from "react";
import { useExportToExcel } from "../../../../excel";
import { Button, ButtonProps } from "../../../Button";
import { Tooltip } from "../../../Tooltip";
import { useTableContext, useTablePropsContext } from "../../context";
import { renderColumnHeaderAsText } from "../../utils";

import { ReactComponent as ExportIcon } from "./icons/export.svg";

export const ExcelButton = memo<ButtonProps>((props) => {
  const table = useTableContext<any>();
  const tableProps = useTablePropsContext<any>();

  return (
    <Tooltip content={"Export to Excel"}>
      <Button
        buttonSize="md"
        buttonType="secondaryGray"
        {...props}
        onClick={useExportToExcel<any>({
          getColumns: () => table!.getAllLeafColumns()
            ?.filter(column => !column.columnDef.meta!.disableExportToExcel)
            ?.filter(column => column.getIsVisible())
            ?.map(column => ({
              name: renderColumnHeaderAsText(column),
              cellAccessor: (row) => {
                try {
                  const value = column.accessorFn!(row, -1);
                  const valueModifier = column.columnDef.meta!.excelProps?.valueModifier;
                  return valueModifier ? valueModifier?.(value) : value as any;
                } catch {
                  throw new Error("Unsupported excel accessor");
                }
              },
              width: ((column.getSize() as number) / 10),
              ...column.columnDef.meta!.excelProps,
            })) || [],
          getItems: async () => await tableProps.getAllTableData?.(table) || [],
          fileName: tableProps.tableId,
          additionalProps: tableProps.createExcelProps,
          messageKey: "exportToExcel_" + tableProps.tableId,
        })}
        iconOnly
      >
        <ExportIcon />
      </Button>
    </Tooltip>
  );
});